import classNames from "classnames";
import { useCallback, useContext, useEffect, useState } from "react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";

// context
import { ContractContext } from "../../../providers/contract";
import { ROUTES } from "../../../setup/constants";
import LeftSection from "./LeftSection";
import RightSection from "./RightSection";
// styles
import styles from "./styles.module.scss";
import { getMilestoneContracts } from "../../../setup/api/services/contract";
import { IContractDetailsResponseData } from "../../../setup/api/services/contract/models";

const MilestoneContractDetails = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { contract, actions } = useContext(ContractContext);
  const [milestones, setMilestones] = useState<IContractDetailsResponseData[]>(
    []
  );

  const fetchMilestoneDetails = useCallback(
    async (id: string) => {
      try {
        const response = await getMilestoneContracts({ complexParentId: id });
        setMilestones(response?.data?.content);
      } catch (error) {
        navigate(ROUTES.CONTRACT_NOT_FOUND);
        console.error(error);
      }
    },
    [navigate]
  );

  useEffect(() => {
    if (id) fetchMilestoneDetails(id);
  }, [fetchMilestoneDetails, id]);

  const refreshContractDetails = () => {
    if (id) actions?.getContract();
  };

  const back = () => {
    try {
      if (window?.history?.state) {
        navigate(-1);
      } else navigate(ROUTES.HOME);
    } catch (error) {
      navigate(ROUTES.HOME);
    }
  };

  return (
    <>
      <div className={classNames(styles["outter_container"])}>
        {contract && (
          <div
            className={classNames(
              styles["container"],
              styles["wide_container"]
            )}>
            <div className={classNames("card", styles["left_section"])}>
              <RightSection backHandler={back} milestones={milestones} />
            </div>
            {/* <div className={classNames("card", styles["right_section"])}>
              <LeftSection
                contract={contract}
                refreshContractDetails={refreshContractDetails}
              />
            </div> */}
          </div>
        )}
      </div>
    </>
  );
};

export default MilestoneContractDetails;
